document.addEventListener('DOMContentLoaded', function() {

  document.querySelector('.cart-drawer__footer .totals').addEventListener('touchstart', function(e) {

  e.stopPropagation();
});

document.querySelector('.cart-drawer__footer .totals').addEventListener('touchmove', function(e) {
  
  e.stopPropagation();
});

  
    function isIE() {
      const ua = window.navigator.userAgent;
      const msie = ua.indexOf('MSIE ');
      const trident = ua.indexOf('Trident/');

      return (msie > 0 || trident > 0);
    }

    if (!isIE()) return;
    const cartSubmitInput = document.createElement('input');
    if (cartSubmitInput) {
    cartSubmitInput.setAttribute('name', 'checkout');
    cartSubmitInput.setAttribute('type', 'hidden');
    document.querySelector('#cart').appendChild(cartSubmitInput);
    document.querySelector('#checkout').addEventListener('click', function(event) {
      document.querySelector('#cart').submit();
    });
      }
  });

document.addEventListener('DOMContentLoaded', () => {
    
const targetElement = document.querySelector('.mainClassWrap');


const observer = new MutationObserver((mutationsList) => {
  for (let mutation of mutationsList) {
   
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      const target = mutation.target;
      if (target.classList.contains('showMeNow')) {
       
        let whiteOverlayForDelete = document.querySelector('.whiteOverlay');
        if (whiteOverlayForDelete) {
  whiteOverlayForDelete.remove();
}
      }
    }
  }
});

observer.observe(targetElement, { attributes: true, subtree: true });


  });

function findClosestDropdown(element, selector) {
  var parentElement = element.parentElement;

  while (parentElement) {
    if (parentElement.classList.contains(selector.substring(1))) {
      return parentElement;
    }
    parentElement = parentElement.parentElement;
  }

  return null;
}


function setBorder(parentQuantity, show) {
  parentQuantity.style.border = show ? 'none' : '1px solid #949494';
}

function closeDropdowns() {
  const allDropdowns = document.querySelectorAll('.dropdown-content');
  if (allDropdowns.length > 0) {
    
  allDropdowns.forEach(dropdown => {
    dropdown.classList.remove('show');
    setBorder(dropdown.closest('.quantity'), false);
    dropdown.style.opacity = '0';
  });
    }
  const parentQuantitys = document.querySelectorAll('.quantity');
  if (parentQuantitys.length > 0) {
    parentQuantitys.forEach((parentQuantity) => {    
    parentQuantity.setAttribute('style', 'min-height: 0px !important');
    parentQuantity.style.transition = 'min-height 0.2s linear';
    parentQuantity.style.alignItems = 'center';
    parentQuantity.style.paddingTop = '0px';
      });
    }
  const qInput = document.querySelectorAll('cart-drawer .cart__quantity-input');
  if (qInput.length > 0) {
    qInput.forEach((input) => {
      input.style.visibility = 'visible';
    });
  }
}

function newQuantityButton(event) {
  const parentQuantity = event.target.closest('.quantity');
  const dropdownContent = parentQuantity.querySelector('.dropdown-content');
  const upsellQuantityOpt = event.target.closest('.upsellQuantityOpt');
  const dropdown2 = event.target.closest('.dropdown');
  const qInput = parentQuantity.querySelector('.cart__quantity-input');

  if (dropdownContent.classList.contains('show')) {
    dropdownContent.classList.remove('show');
    setBorder(parentQuantity, false);
    parentQuantity.setAttribute('style', 'min-height: 0px !important');
    parentQuantity.style.transition = 'min-height 0.2s linear';
    parentQuantity.style.alignItems = 'center';
    parentQuantity.style.paddingTop = '0px';
    dropdownContent.style.opacity = '0';
    console.log('qInput', qInput);
    qInput.style.visibility = 'visible';
  } else {
    closeDropdowns();
    dropdownContent.classList.add('show');
    qInput.style.visibility = 'hidden';
    dropdownContent.style.width = '40%';
    
    setBorder(parentQuantity, true);
    parentQuantity.setAttribute('style', 'min-height: 150px !important');
    parentQuantity.style.transition = 'min-height 0.5s linear';
    parentQuantity.style.alignItems = 'flex-start';
    parentQuantity.style.paddingTop = '17px';
    parentQuantity.style.zIndex = '99';
    let currentOpacity = 0;
const targetOpacity = 1;
const duration = 500; // время в миллисекундах (0.5 секунды)
const interval = 10; // интервал в миллисекундах
setTimeout(() => {
const fadeInInterval = setInterval(() => {
  currentOpacity += interval / duration;
  dropdownContent.style.opacity = Math.min(currentOpacity, targetOpacity);

  if (currentOpacity >= targetOpacity) {
    clearInterval(fadeInInterval);
  }
}, interval);
},400);  
    
  }

  const numberLinks = dropdownContent.querySelectorAll('a');

  numberLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const selectedNumber = this.textContent;
      const inputField = parentQuantity.querySelector('.cart__quantity-input');
      parentQuantity.setAttribute('style', 'min-height: 0px !important');
    parentQuantity.style.transition = 'min-height 0.2s linear';
    parentQuantity.style.alignItems = 'center';
    parentQuantity.style.paddingTop = '0px';
    dropdownContent.style.opacity = '0';

      if (inputField) {
        inputField.value = selectedNumber;
        inputField.dispatchEvent(new Event('change', { bubbles: true }));
      }

      closeDropdowns();
    });
  });
  setTimeout(async () => {
    var currentURL = window.location.href;
var parts = currentURL.split('/');
var trimmedLanguageNow = parts[3].slice(0,2);  
    
    let url;

    switch (trimmedLanguageNow) {
        case 'fr':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/FR_Sandra_reviewed_9_04.json?v=1712638887';
            break;
        case 'de':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/DE_Sandra_reviewed_9_04.json?v=1712638888';
            break;
        case 'ru':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/RU_Alex_040424_full_c3955efc-1d94-4df1-9d8c-ae8c2780d49b.json?v=1712322526';
            break;
        case 'it':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/IT_Sandra_reviewed_9_04.json?v=1712638887';
            break;
        case 'zh':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/CN_Alex_040424_full_b1bdcc27-55a2-4300-9797-724167ed99d7.json?v=1712322527';
            break;
        default:
            break;
    }

    if (url) {
        const response = await fetch(url);
        const data = await response.json();
        TranslationFormButtons(data);
    }
}, 1500);
}

document.addEventListener('click', function(e) {
  if (!e.target.closest('.quantity')) {    
    closeDropdowns();
  
  }
});





document.addEventListener('DOMContentLoaded', () => {
      const deleteCartBug = document.querySelector('cart-drawer');
    const totalsValue = document.querySelector('.totals__subtotal-value').textContent;
  

if (totalsValue !== '0,00 € EUR') {
  if (deleteCartBug.classList.contains('is-empty')) {
  deleteCartBug.classList.remove('is-empty');
}
  
} else {
 
}

    
  });

 function toTranslate() {
   setTimeout(async () => {
      var currentURL = window.location.href;
var parts = currentURL.split('/');
var trimmedLanguageNow = parts[3].slice(0,2);  

let response, data;

     
switch (trimmedLanguageNow) {
  case 'fr':
    response = await fetch('https://cdn.shopify.com/s/files/1/0665/2798/5877/files/FR_Sandra_reviewed_9_04.json?v=1712638887');
    data = await response.json();
    TranslationFormButtons(data);
    TranslationDrawer(data);
    break;
  case 'de':
    response = await fetch('https://cdn.shopify.com/s/files/1/0665/2798/5877/files/DE_Sandra_reviewed_9_04.json?v=1712638888');
    data = await response.json();
    TranslationFormButtons(data);
    TranslationDrawer(data);
    break;
  case 'it':
    response = await fetch('https://cdn.shopify.com/s/files/1/0665/2798/5877/files/IT_Sandra_reviewed_9_04.json?v=1712638887');
    data = await response.json();
    TranslationFormButtons(data);
    TranslationDrawer(data);
    break;
  case 'ru':
    response = await fetch('https://cdn.shopify.com/s/files/1/0665/2798/5877/files/RU_Alex_040424_full_c3955efc-1d94-4df1-9d8c-ae8c2780d49b.json?v=1712322526');
    data = await response.json();
    TranslationFormButtons(data);
    TranslationDrawer(data);
    break;
  case 'zh':
    response = await fetch('https://cdn.shopify.com/s/files/1/0665/2798/5877/files/CN_Alex_040424_full_b1bdcc27-55a2-4300-9797-724167ed99d7.json?v=1712322527');
    data = await response.json();
    TranslationFormButtons(data);
    TranslationDrawer(data);
    break;
  default:
    break;
}

    },1500);
}
  
 document.addEventListener('DOMContentLoaded', () => {
  function handleMutation(mutationsList, observer) {

    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
  for (let mutation of mutationsList) {
    mutation.addedNodes.forEach(function (node) {
      if (node.nodeType === Node.ELEMENT_NODE) {
        const pp1Elements = node.querySelectorAll('.pp1');
        if (pp1Elements.length > 0) {
          
          const pp2Observe = document.querySelector('cart-drawer .product_pp2');
         
          pp2Observe.setAttribute('style', 'display: flex !important;');
        }
      }
    });
  }
}

    }
  }

  const drawerElement = document.querySelector('cart-drawer'); 
  if (drawerElement) {
    const observer = new MutationObserver(handleMutation);

    const config = {
      childList: true,
      attributes: false,
      subtree: true 
    };

    observer.observe(drawerElement, config);
  }
});

function deleteAction() {
   
    const drawerActive = document.querySelectorAll('.cart-drawer-preloader');
     
      console.log('drawerActive', drawerActive);
      if (drawerActive.length > 0 ) {
      
        drawerActive.forEach((drA) => {    
          if (drA.classList.contains('active')) {
          
            drA.classList.remove('active');

          }          
        });
      }
    
    };




